import cx from 'classnames';
import createReactAngularDirective from '../../lib/createReactAngularDirective';
import s from '../../controllers/Step4/step4Ctrl.module.css';
import { ConfirmationPage } from '../../react-components/ConfirmationPage';
import { returnItemsService } from '../../services';

export default createReactAngularDirective({
  Component: ConfirmationPage,
  directiveName: 'confirmationPage',
  withProvider: true,
  watch: true,
  replace: true,
  dynamicTemplate: () => {
    return `<div class="${cx(s.step_4_container, `step-4-container-${returnItemsService.getMethod()}`)}"></div>`;
  },
});
